module.exports = __webpack_public_path__ + "img/skull.d2923763.svg";